import { api } from './api';

export type ScheduleConflict = {
  type: 'teacher_overlap' | 'room_overlap' | 'availability_violation';
  severity: 'error' | 'warning';
  message: string;
  reason?: string | null;
  source?: string | null;
  details?: Record<string, unknown> | null;
  references?: Array<{
    id: number;
    course_id?: number | null;
    course_name?: string;
    start_zeit?: string;
    end_zeit?: string;
    status?: string;
  }>;
};

export type ConflictCheckResult = {
  hasConflict: boolean;
  hasBlockingConflict?: boolean;
  conflicts: ScheduleConflict[];
  suggestions?: Array<{ type: string; label: string }>;
};

export const scheduleConflictsApi = {
  check: async (payload: {
    teacherId?: number | string | null;
    roomId?: number | null;
    standortId?: number | null;
    date: string;
    startTime: string;
    endTime: string;
    excludeUnitId?: number | null;
    /** Der Kurstermin (Kurs + Tag), der gerade wandert — er kollidiert nicht mit sich selbst. */
    excludeCourseId?: number | null;
    excludeDate?: string | null;
    /** Die Probestunde, die gerade wandert. */
    excludeTrialId?: number | null;
  }): Promise<ConflictCheckResult> => {
    try {
      return await api.post<ConflictCheckResult>('/api/schedule/conflict-check', payload);
    } catch (error: any) {
      const msg = String(error?.message || '');
      const isNotFound = msg.includes('404') || msg.toLowerCase().includes('not found');
      if (!isNotFound) throw error;
      // Fallback für Deployments, in denen /api bereits auf Backend-Root gemappt ist.
      return await api.post<ConflictCheckResult>('/schedule/conflict-check', payload);
    }
  },
};

